<template>
  <div v-if="dataPermohonan.status >= 15 ">
    <hr>
    <div class="form-group row">
      <label
        for=""
        class="col-form-label col-md-3 text-md-right text-left"
      >Opsi Pengambilan Dokumen</label>
      <div class="col-md-9">
        <div class="custom-control custom-radio">
          <input
            type="radio"
            id="opsiAmbilSendiriDukcapil"
            name="opsi_ambil_berkas"
            class="custom-control-input"
            value="1"
            v-model="formAmbilBerkas.opsi_ambil_berkas"
            :disabled="disabledOpsiAmbilBerkas"
          >
          <label
            class="custom-control-label"
            for="opsiAmbilSendiriDukcapil"
          >Ambil Sendiri Ke Dukcapil</label>
        </div>
        <div class="custom-control custom-radio">
          <input
            type="radio"
            id="opsiAmbilSendiriDesa"
            name="opsi_ambil_berkas"
            class="custom-control-input"
            value="2"
            v-model="formAmbilBerkas.opsi_ambil_berkas"
            :disabled="disabledOpsiAmbilBerkas"
          >
          <label
            class="custom-control-label"
            for="opsiAmbilSendiriDesa"
          >Ambil Sendiri Ke Kantor Desa</label>
        </div>
        <!-- hide dulu -->
        <div class="custom-control custom-radio">
          <input
            type="radio"
            id="opsiAmbilDiAngkringan"
            name="opsi_ambil_berkas"
            class="custom-control-input"
            :value="4"
            v-model="formAmbilBerkas.opsi_ambil_berkas"
            :disabled="disabledOpsiAmbilBerkas"
          >
          <label
            class="custom-control-label"
            for="opsiAmbilDiAngkringan"
          >Ambil Sendiri Ke Angkringan</label>
        </div>
        
        <div class="custom-control custom-radio">
          <input
            type="radio"
            id="opsiDiantarAngkringan"
            name="opsi_ambil_berkas"
            class="custom-control-input"
            :value="5"
            v-model="formAmbilBerkas.opsi_ambil_berkas"
            :disabled="disabledOpsiAmbilBerkas"
          >
          <label
            class="custom-control-label"
            for="opsiDiantarAngkringan"
          >Diambilkan Jasa Antar Dari Angkringan</label>
        </div>
        <!-- <div class="custom-control custom-radio">
                    <input type="radio" id="opsiAmbilGojek" name="opsi_ambil_berkas" class="custom-control-input" value="3"
                        v-model="formAmbilBerkas.opsi_ambil_berkas" :disabled="dataPermohonan.status === 16 || namaRole !='Penduduk'">
                    <label class="custom-control-label" for="opsiAmbilGojek">Melalui Jasa Pengiriman</label>
                </div> -->
        <div class="custom-control custom-radio">
          <input
            type="radio"
            id="opsiBelumDitentukan"
            name="opsi_ambil_berkas"
            class="custom-control-input"
            value="0"
            v-model="formAmbilBerkas.opsi_ambil_berkas"
            :disabled="disabledOpsiAmbilBerkas"
          >
          <label
            class="custom-control-label"
            for="opsiBelumDitentukan"
          >Belum Menentukan</label>
        </div>
      </div>
    </div>
    <!-- form tanggal angkringan -->
    <div
      v-if="[4, 5].includes(formAmbilBerkas.opsi_ambil_berkas)"
      class="form-group row"
    >
      <label
        for=""
        class="col-form-label col-md-3 text-md-right text-left"
      >Tanggal Ke/Dari Angkringan</label>
      <div class="col-md-3">
        <input
          v-model="formAmbilBerkas.waktu_ke_dari_angkringan"
          type="datetime-local"
          class="form-control"
        >
      </div>
    </div>
    <!-- form pesanan -->
    <div
      v-if="[4, 5].includes(formAmbilBerkas.opsi_ambil_berkas)"
      class="form-group row"
    >
      <label
        for=""
        class="col-form-label col-md-3 text-md-right text-left"
      >Pesan Makanan/Minuman Di Angkringan</label>
      <div class="col-md-9">
        <!-- list menu -->
        <div
          style="max-height: 300px; overflow-y: auto; overflow-x: hidden"
        >
          <DetailPermohonanListMenuUmkm
            :tanggal-ambil="formAmbilBerkas.waktu_ke_dari_angkringan"
            :pesanan="pesanan"
            @loadPesanan="loadPesanan"
          />
        </div>
      </div>
    </div>
    <!-- form pesanan yang dipilih -->
    <div
      v-if="[4, 5].includes(formAmbilBerkas.opsi_ambil_berkas)"
      class="form-group row"
    >
      <label
        for=""
        class="col-form-label col-md-3 text-md-right text-left"
      >Pesanan Anda</label>
      <div
        class="col-md-9"
        style="max-height: 300px; overflow-x: hidden; overflow-y: auto"
      >
        <div
          v-if="pesanan && pesanan.det_pesanan.length > 0"
        >
          <div
            v-for="p in pesanan.det_pesanan"
            :key="'pes-'+p.id_det_pesanan"
          >
            <div class="row">
              <div>
                <img
                  v-if="!p.menu_umkm.foto"
                  class="card-img-top"
                  :src="require('./../../assets/stisla/img/news/img01.jpg')"
                  style="width: 100px"
                >
                <img
                  v-else
                  class="card-img-top"
                  :src="$store.getters.getBaseUrl + '/api/file/' + p.menu_umkm.foto"
                  style="width: 100px"
                >
              </div>
              <div class="col">
                <b>{{ p.menu_umkm.nama_menu }}</b>
              </div>
              <div class="col">
                <p class="text-right">
                  Rp {{ p.harga.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") }}
                </p>
              </div>
              <div class="col">
                <b>Jumlah:</b>
                {{ p.jumlah }}
                <button
                  v-if="(namaRole === 'Penduduk' || namaRole === 'Operator Desa')"
                  class="btn btn-link m-1"
                  @click="editPesanan(p)"
                >
                  Edit
                </button>
              </div>
              <div class="col">
                <b>Rp {{ (p.jumlah * p.harga).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") }}</b>
              </div>
              <div class="col">
                <button
                  v-if="(namaRole === 'Penduduk' || namaRole === 'Operator Desa')"
                  class="btn btn-danger m-1"
                  @click="hapusPesanan(p)"
                >
                  <i class="fa fa-trash" />
                </button>
              </div>
            </div>
          </div>
        </div>
        <div v-else>
          Tidak ada pesanan
        </div>
      </div>
    </div>
    <!-- Total Pesanan -->
    <div
      v-if="[4, 5].includes(formAmbilBerkas.opsi_ambil_berkas)"
      class="form-group row"
    >
      <label
        for=""
        class="col-form-label col-md-3 text-md-right text-left"
      >Total</label>
      <div
        v-if="pesanan"
        class="col-md-9"
      >
        <b>Rp{{ pesanan.total.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") }}</b>
      </div>
    </div>
    <div class="form-group row">
      <label
        for=""
        class="col-form-label col-md-3 text-md-right text-left"
      >Keterangan Tambahan (bila ada)</label>
      <div class="col-md-9">
        <textarea
          class="form-control"
          v-model="formAmbilBerkas.keterangan_ambil_berkas"
          :disabled="disabledOpsiAmbilBerkas"
        />
      </div>
    </div>
    <div
      class="form-group row"
      v-if="isBisaSimpanOpsi"
    >
      <div class="col-md-9 offset-md-3">
        <button
          v-if="dataPermohonan.status === 15"
          class="btn btn-primary mt-3"
          @click="setOpsiAmbilBerkas($event)"
        >
          <i class="fa fa-check mr-2" />Simpan Opsi
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import swal from 'sweetalert'
import DetailPermohonanListMenuUmkm from './DetailPermohonanListMenuUmkm.vue'

export default {
  components: {
    DetailPermohonanListMenuUmkm
  },
  data() {
    return {
      formAmbilBerkas: {
        opsi_ambil_berkas: null,
        keterangan_ambil_berkas: '',
        waktu_ke_dari_angkringan: ''
      },
      pesanan: null
    }
  },
  computed: {
    namaRole() {
      return this.$store.getters.getAuthService.currentRole.nama_role
    },
    dataPermohonan() {
      return this.$store.getters.getDataPermohonan
    },
    disabledOpsiAmbilBerkas() {
      let isDisabled = true
      if (this.dataPermohonan.id_operator_pembantu) {
        if (this.dataPermohonan.status == 15) {
          if (this.namaRole == 'Kepala Desa' || this.namaRole == 'Operator Desa') {
            isDisabled = false
          }
        }
      } else {
        if (this.dataPermohonan.status == 15) {
          if (this.namaRole == 'Penduduk') {
            isDisabled = false
          }
        }
      }

      return isDisabled
    },
    isBisaSimpanOpsi() {
      let isBisa = false
      if (this.dataPermohonan.id_operator_pembantu) {
        if (this.dataPermohonan.status == 15) {
          if (this.namaRole == 'Kepala Desa' || this.namaRole == 'Operator Desa') {
            isBisa = true
          }
        }
      } else {
        if (this.dataPermohonan.status == 15) {
          if (this.namaRole == 'Penduduk') {
            isBisa = true
          }
        }
      }
      return isBisa
    }
  },
  methods: {
    setFormOpsi(data) {
      if (data.status >= 15) {
        this.formAmbilBerkas.opsi_ambil_berkas = data.opsi_ambil_berkas
        this.formAmbilBerkas.keterangan_ambil_berkas = data.keterangan_ambil_berkas
        console.log(this.formAmbilBerkas.opsi_ambil_berkas)
        if ([4, 5].includes(this.formAmbilBerkas.opsi_ambil_berkas)) {
          this.formAmbilBerkas.waktu_ke_dari_angkringan = data.waktu_ke_dari_angkringan.replace(' ', 'T')
        }
      }
    },
    setOpsiAmbilBerkas(e) {
      console.log(this.formAmbilBerkas.waktu_ke_dari_angkringan)
      if ([4, 5].includes(this.formAmbilBerkas.opsi_ambil_berkas)) {
        if (this.formAmbilBerkas.waktu_ke_dari_angkringan === '') {
          swal({
            title: "Gagal",
            text: "Pilih Tanggal Ke/Dari Angkringan",
            icon: "error",
            buttons: "Ok"
          })
          return false
        }
      }
      let button = e.target
      let buttonHtml = button.innerHTML

      button.setAttribute('disabled', true)
      button.innerHTML = '<i class="fa fa-spin fa-spinner mr-2"></i>Simpan Opsi'

      let formData = new FormData()
      formData.append('opsi_ambil_berkas', this.formAmbilBerkas.opsi_ambil_berkas)
      formData.append('keterangan_ambil_berkas', (!this.formAmbilBerkas.keterangan_ambil_berkas || this.formAmbilBerkas.keterangan_ambil_berkas == '') ? '-' : this.formAmbilBerkas.keterangan_ambil_berkas)

      if (this.namaRole === 'Operator Desa' || this.namaRole === 'Kepala Desa') {
        formData.append('is_operator_desa', 1)
      }

      if ([4, 5].includes(this.formAmbilBerkas.opsi_ambil_berkas)) {
        formData.append('waktu_ke_dari_angkringan', this.formAmbilBerkas.waktu_ke_dari_angkringan)
      }


      let idDataPermohonan = this.dataPermohonan.id_data_permohonan

      this.$store.dispatch('updatePermohonanPenduduk', { id: idDataPermohonan, form: formData }).then(res => {
        if (res.data.status) {
          swal({
            title: "Berhasil",
            text: "Berhasil mengatur opsi pengambilan berkas",
            icon: "success",
            buttons: "Ok"
          })


          this.notify({
            type_notif: 'STATUS_PERMOHONAN',
            type_receiver: 'operator_dukcapil',
            id_data_permohonan: idDataPermohonan,
            status_permohonan: 15,
            via: 'mail,fcm',
            title_notif: `Penduduk Siap Mengambil Berkas`,
            body_notif: `Silahkan login ke aplikasi untuk melihat detail`
          })


          this.$emit('showPermohonan')

        } else {
          swal({
            title: "Gagal",
            text: res.data.message,
            icon: "error",
            buttons: "Ok"
          })
        }
        button.removeAttribute('disabled')
        button.innerHTML = buttonHtml
      }).catch(err => {
        switch (err.response.status) {
          case 500:
            this.$router.push({ path: '/500' })
            break;

          case 400:
            swal({
              title: "Gagal",
              text: (typeof (err.response.data.message) === 'object') ? 'Ada kesalahan teknis. Harap hubungi operator' : err.response.data.message,
              icon: "error",
              buttons: "Ok"
            })
            break;

          default:
            swal({
              title: "Gagal",
              text: err.response.data.message,
              icon: "error",
              buttons: "Ok"
            })
            break;
        }
        button.removeAttribute('disabled')
        button.innerHTML = buttonHtml
      })
    },
    notify(data) {
      let formData = new FormData
      for (let key in data) {
        formData.append(key, data[key])
      }

      this.$store.dispatch('sendNotifikasi', formData).then(r => {
        // console.log(r)
      })
    },
    loadPesanan() {
      console.log('load pesanan')
      this.$store.dispatch('fetchPesananByPermohonan', {
        id_data_permohonan: this.dataPermohonan.id_data_permohonan
      })
        .then((res) => {
          if(res.data.status) {
            this.pesanan = res.data.data
          } else {
            //
          }
        })
        .catch(() => {
          //
        })
    },
    hapusPesanan(row) {
      const formData = new FormData()
      formData.append('id_menu_umkm', row.id_menu_umkm)
      formData.append('id_data_permohonan', this.dataPermohonan.id_data_permohonan)

      this.$store.dispatch('hapusPesanan', formData).then((res) => {
        if (res.data.status) {
          swal({
            title: "Berhasil",
            text: res.data.message,
            icon: "success",
            buttons: "Ok"
          })
          this.loadPesanan()
        } else {
          swal({
            title: "Gagal",
            text: res.data.message,
            icon: "error",
            buttons: "Ok"
          })
        }
      })
        .catch(() => {
          swal({
            title: "Gagal",
            text: "Ada kesalahan teknis. Coba lagi nanti.",
            icon: "error",
            buttons: "Ok"
          })
        })
    },
    editPesanan (row) {
      console.log(row)
      swal("", {
        title: "Jumlah",
        icon: "warning",
        buttons: {
          cancel: "Batal",
          confirm: "Simpan"
        },
        content: "input",
      })
        .then((res) => {
          if (res) {
            let jumlah = res
            this.submitEditPesanan(row.id_menu_umkm, jumlah)
          }
        })
    },
    submitEditPesanan (id, jumlah) {
      const formData = new FormData()
      formData.append('id_menu_umkm', id)
      formData.append('jumlah', jumlah)
      formData.append('id_data_permohonan', this.dataPermohonan.id_data_permohonan)
      this.$store.dispatch('updatePesanan', formData).then((res) => {
        if (res.data.status) {
          swal({
            title: "Berhasil",
            text: res.data.message,
            icon: "success",
            buttons: "Ok"
          })
          this.loadPesanan()
        } else {
          swal({
            title: "Gagal",
            text: res.data.message,
            icon: "error",
            buttons: "Ok"
          })
        }
      })
        .catch(() => {
          swal({
            title: "Gagal",
            text: "Ada kesalahan teknis. Coba lagi nanti.",
            icon: "error",
            buttons: "Ok"
          })
        })
    }
  },
  created() {
    if (this.dataPermohonan) {
      if (this.dataPermohonan.id_data_permohonan) {
        this.setFormOpsi(this.dataPermohonan)

        // this.loadPesanan()
      }
    }
  },
  watch: {
    dataPermohonan(newVal) {
      if (newVal.id_data_permohonan) {
        this.setFormOpsi(newVal)

        this.loadPesanan()
      }
    }
  }
}
</script>